import { createFetch } from '@better-fetch/fetch'
import { logger } from '@better-fetch/logger'

import { apiSchema } from '@/services/schemas'

const $fetch = createFetch({
  baseURL: import.meta.env.VITE_API_URL,
  schema: apiSchema,
  plugins: [
    logger({
      enabled: import.meta.env.DEV,
    }),
  ],
})

export default $fetch
